import React from 'react';
import { relocationPages } from '../../data/relocation';
import SEO from '../../components/SEO';

const RelocationSchools = () => {
  const pageData = relocationPages.schools;

  return (
    <div className="min-h-screen bg-[#F9F6EF]">
      <SEO
        title="International Schools in Mexico City"
        description="Top international schools in Mexico City for expat families. American, British, and bilingual schools with tuition, curriculum, and admission details."
        path="/relocation/schools"
      />
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#F9F6EF] border-b border-[#F4ECD8]">
        <div className="container-wide mx-auto px-8 py-5">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
            </a>
            <nav className="hidden md:flex items-center gap-8">
              <a href="/" className="text-sm font-medium text-[#1A5C6E] hover:text-[#2CA8A0] transition">Home</a>
              <a href="/relocation/cdmx" className="text-sm font-medium text-[#0A1F2E]">Relocation</a>
              <a href="/contact" className="btn-primary text-xs px-6 py-3">Contact</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="section">
        <div className="container-wide mx-auto">
          <a href="/relocation/cdmx" className="inline-block text-sm font-medium text-[#5A6B73] mb-6 hover:text-[#2CA8A0] transition">
            ← Back to Relocation Hub
          </a>
          <p className="label mb-4">Relocation Hub</p>
          <h1 className="heading-xl mb-6">{pageData.title}</h1>
          <p className="body-lg max-w-3xl">{pageData.description}</p>
        </div>
      </section>

      {/* School Types */}
      <section className="section-sm bg-[#FFFFFF]">
        <div className="container-wide mx-auto">
          <h2 className="heading-lg mb-8 text-center">School Options</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {pageData.schoolTypes.map((school, idx) => (
              <div key={idx} className="bg-[#FFFFFF] border border-[#E0D6B8] p-6">
                <h3 className="heading-sm mb-2">{school.type}</h3>
                <p className="body-md mb-4">{school.description}</p>
                
                <h4 className="text-sm font-medium mb-2 text-[#0A1F2E]">Examples:</h4>
                <ul className="space-y-1 mb-4">
                  {school.examples.map((ex, exIdx) => (
                    <li key={exIdx} className="body-sm text-[#1A5C6E]">• {ex}</li>
                  ))}
                </ul>
                
                <p className="text-sm font-semibold text-[#2CA8A0]">{school.priceRange}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tips */}
      <section className="section">
        <div className="container-narrow mx-auto">
          <h2 className="heading-lg mb-8 text-center">School Selection Tips</h2>
          
          <div className="space-y-6">
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">Start Early</h3>
              <p className="body-md">Top international schools have waitlists. Begin research 6-12 months before your move. Applications often require transcripts, recommendations, and student assessments.</p>
            </div>
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">Consider Location</h3>
              <p className="body-md">School location often determines neighborhood choice. Traffic can be significant-prioritize schools within reasonable distance from home.</p>
            </div>
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">Language Considerations</h3>
              <p className="body-md">International schools offer full English instruction. Bilingual schools provide gradual Spanish immersion. Consider your child's age and language goals.</p>
            </div>
            <div>
              <h3 className="heading-sm mb-3">Visit Before Committing</h3>
              <p className="body-md">If possible, schedule school visits during a scouting trip. Meet administrators, tour facilities, and understand the community fit.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-sm bg-[#FFFFFF] border-t border-[#F4ECD8]">
        <div className="container-narrow mx-auto text-center">
          <h2 className="heading-lg mb-4">Need School Guidance?</h2>
          <p className="body-md mb-8">
            Our Guided and White Glove plans include school recommendations tailored to your family.
          </p>
          <a href="/relocation/blueprint" className="btn-primary">View Relocation Plans</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="section-sm border-t border-[#F4ECD8]">
        <div className="container-wide mx-auto text-center">
          <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
          <p className="body-sm">© {new Date().getFullYear()} Mundalo. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default RelocationSchools;
